import { Chip } from '@mui/joy';
import { Link as LinkIcon, Users, UserCircle, UsersThree } from '@phosphor-icons/react';
import { POST_ACCESS, normalizeAccess } from '../../../../config/configPostAccess';

/** Иконка на каждый режим — по ней метка читается быстрее, чем по тексту. */
const ICONS = {
    [POST_ACCESS.SUBSCRIBERS]: Users,
    [POST_ACCESS.SUBSCRIPTIONS]: UserCircle,
    [POST_ACCESS.BOTH]: UsersThree,
    [POST_ACCESS.LINK]: LinkIcon,
};

/** Короткие подписи: в карточке места мало, полные формулировки не влезут. */
const LABELS = {
    [POST_ACCESS.SUBSCRIBERS]: 'Подписчикам',
    [POST_ACCESS.SUBSCRIPTIONS]: 'Подпискам',
    [POST_ACCESS.BOTH]: 'Подписчикам и подпискам',
    [POST_ACCESS.LINK]: 'По ссылке',
};

/**
 * Метка ограниченного доступа записи.
 *
 * Нужна прежде всего автору: он видит свою запись в ленте и должен понимать,
 * что её видят не все. У открытых записей метки нет — она была бы шумом на
 * подавляющем большинстве записей.
 *
 * @param {number} access - значение из `posts.access`
 */
export default function AccessChip({ access }) {
    const value = normalizeAccess(access);
    if (value === POST_ACCESS.PUBLIC) return null;

    const Icon = ICONS[value];

    return (
        <Chip
            color="neutral"
            size="sm"
            variant="outlined"
            startDecorator={Icon ? <Icon size={14} /> : null}
        >
            {LABELS[value]}
        </Chip>
    );
}
